export const DEFAULT_WHATSAPP_NUMBER = "5512997044344";

let WHATSAPP_NUMBER_RUNTIME = DEFAULT_WHATSAPP_NUMBER;

export const setWhatsAppNumber = (n) => {
  if (n) WHATSAPP_NUMBER_RUNTIME = String(n);
};

export const getWhatsAppNumber = () => WHATSAPP_NUMBER_RUNTIME;

export const WHATSAPP_GREETING =
  "Olá! Estou no site do Quiosque Rainha do Mar e gostaria de informações e reservas.";

export const getWhatsAppLink = (text = WHATSAPP_GREETING) =>
  `https://wa.me/${WHATSAPP_NUMBER_RUNTIME}?text=${encodeURIComponent(text)}`;

export const MAPS_EMBED =
  "https://www.openstreetmap.org/export/embed.html?bbox=-45.1240%2C-23.5260%2C-45.1030%2C-23.5130&layer=mapnik&marker=-23.5197%2C-45.1136";

export const MAPS_DIRECTIONS =
  "https://www.google.com/maps/dir/?api=1&destination=Praia%20da%20Sete%20Fontes%2C%20Ubatuba%20-%20SP";

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -84, duration: 1.4 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};

export const buildReservationWhatsApp = ({ name, guests, seating, message }) => {
  const lines = [
    "Olá! Quero confirmar minha reserva no Quiosque Rainha do Mar:",
    `• Nome: ${name}`,
    `• Pessoas: ${guests}`,
    `• Mesa: ${seating}`,
  ];
  if (message) lines.push(`• Obs: ${message}`);
  return `https://wa.me/${WHATSAPP_NUMBER_RUNTIME}?text=${encodeURIComponent(lines.join("\n"))}`;
};

export const getSunPhase = () => {
  const hour = parseInt(
    new Date().toLocaleString("en-US", { timeZone: "America/Sao_Paulo", hour: "2-digit", hour12: false }),
    10
  );
  if (hour >= 6 && hour < 17) return "day";
  if (hour >= 17 && hour < 19) return "golden";
  return "night";
};

// Resolve an image reference to a usable URL.
// - "/images/..." (bundled) and absolute http(s) are used as-is.
// - "/api/files/..." (uploaded to object storage) is prefixed with the backend URL.
export const resolveImg = (v) => {
  if (!v) return v;
  if (v.startsWith("http") || v.startsWith("/images")) return v;
  if (v.startsWith("/api/")) return `${process.env.REACT_APP_BACKEND_URL}${v}`;
  return v;
};
